import { createAction } from '@reduxjs/toolkit';

import type { ILoadPublicAlbumListSuccess, ILoadPublicAlbumPageSuccess } from './publicAlbum.types';

export const loadPublicAlbumPageRequest = createAction('publicAlbums/loadPublicAlbumPageRequest');
export const loadPublicAlbumPageSuccess = createAction<ILoadPublicAlbumPageSuccess>('publicAlbums/loadAlbumPageSuccess');
export const loadPublicAlbumListSuccess = createAction<ILoadPublicAlbumListSuccess>('publicAlbums/loadPublicAlbumListSuccess');
